import axios from "axios";

export const fetchDisableJobs = async (body: any) => {
  return await axios.post("/api/company/job/disable", body);
};
